import { RowAction } from "@beeldit/core/enums/RowAction.enum";
import { TableAction } from "@beeldit/core/enums/TableAction.enum";
import { Eye, Pencil, Play, Plus, Trash } from "@phosphor-icons/react";
import { t } from "i18next";
import WidgetsArrayFieldTemplate from "./templates/MappingArrayFieldTemplate";
import { placeholderCSS } from "react-select/dist/declarations/src/components/Placeholder";

const config = {
  modelName: "bd-connection",
  modelPluralName: "bd-connections",
  endpoint: "bd-connections",
  tableConfig: {
    index: null,
    actions: [
      {
        name: TableAction.CREATE,
        label: "create",
        showLabel: true,
        allowed: true,
        show: true,
        action: null,
        icon: <Plus size={20} />,
      },
    ],
    rowActions: [
      {
        name: "execute",
        label: "execute",
        icon: <Play size={20} />,
        allowed: true,
        show: (element: any) => {
          return element.status === "Pendiente";
        },
        action: (element: any) => {
          console.log("edit", element);
        },
      },
      {
        name: RowAction.EDIT,
        label: "edit",
        icon: <Pencil size={20} />,
        allowed: true,
        show: true,
        action: (element: any) => {
          console.log("edit", element);
        },
      },
      {
        name: RowAction.DELETE,
        label: "delete",
        icon: <Trash size={20} />,
        allowed: true,
        show: true,
        action: (element: any) => {
          console.log("delete", element);
        },
      },
    ],
    rowConfiguration: {
      class: (element: any) => {
        return null;
      },
    },
    columns: [
      {
        name: "id",
        label: "#",
        key: "id",
        type: "number",
        show: true,
        allowOrder: true,
      },
      {
        name: "name",
        label: "name",
        key: "name",
        type: "string",
        show: true,
        allowOrder: true,
      },
      {
        name: "estado",
        label: "estado",
        key: "status",
        type: "string",
        show: true,
        allowOrder: true,
      },
    ],
    pagination: {
      enabled: true,
      back: true,
    },
  },
  filterConfig: {
    type: "object",
    properties: {
      search: {
        type: "string",
      },
    },
  },
  filterUIConfig: {
    uiScheme: {
      className: "filters-container",
      search: {
        "ui:options": {
          label: false, // Oculta el título del campo
          placeholder: "Buscar...",
        },
      },
    },
    widgets: {},
  },
  formSchema: {
    type: "object",
    properties: {
      // Name
      name: {
        type: "string",
        title: t("name"),
      },
      type: {
        type: ["string", "null"],
        placeholder: "Selecciona una opción",
        title: t("type"),
        oneOf: [
          {
            const: "access",
            title: "Access",
          },
          {
            const: "csv",
            title: "Csv",
          },
          {
            const: "mysql_database",
            title: "Base de datos MySQL",
          },
        ],
      },
      file: {
        type: "string",
        format: "data-url",
        title: "Archivo",
      },
      tableFrom: {
        type: "string",
        title: t("table_from"),
      },
      tableTo: {
        type: "string",
        title: t("table_to"),
      },
      mapping: {
        type: "array",
        title: t("mapping"),
        items: {
          type: "object",
          title: "",
          properties: {
            fieldFrom: {
              type: "string",
              title: t("fieldFrom"),
            },
            fieldFromType: {
              type: "string",
              title: t("fieldFromType"),
              oneOf: [
                {
                  const: "string",
                  title: "texto",
                },
                {
                  const: "number",
                  title: "número",
                },
                {
                  const: "boolean",
                  title: "Booleano",
                },
              ],
            },
            fieldTo: {
              type: "string",
              title: t("fieldTo"),
            },
            fieldToType: {
              type: "string",
              title: t("fieldToType"),
              oneOf: [
                {
                  const: "string",
                  title: "texto",
                },
                {
                  const: "number",
                  title: "número",
                },
                {
                  const: "boolean",
                  title: "Booleano",
                },
              ],
            },
          },
        },
      },
    },
  },
  uiFormSchema: {
    "ui:submitButtonOptions": {
      props: {
        disabled: false,
        className: "btn btn-info",
      },
      norender: true,
    },
    mapping: {
      "ui:ArrayFieldTemplate": WidgetsArrayFieldTemplate,
      items: {
        colsSchema: [
          {
            cols: "col-12",
            elements: [
              [
                {
                  name: "fieldFrom",
                  cols: "col-6",
                },
                {
                  name: "fieldFromType",
                  cols: "col-6",
                },
                {
                  name: "fieldTo",
                  cols: "col-6",
                },
                {
                  name: "fieldToType",
                  cols: "col-6",
                },
              ],
            ],
          },
        ],
      },
    },
  },
};
export default config;
